import { render } from "./PortalDashboard.vue?vue&type=template&id=6a5d3361&scoped=true&ts=true"
import script from "./PortalDashboard.vue?vue&type=script&lang=ts"
export * from "./PortalDashboard.vue?vue&type=script&lang=ts"

import "./PortalDashboard.vue?vue&type=style&index=0&id=6a5d3361&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5d3361"]])

export default __exports__